import React from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';

import { ScreenBody } from '../../../core-components/theme/components/Screen';
import type { LoadState } from '../../../core-components/theme/components/Screen';
import { useOnboardingGate } from '../hooks/useOnboardingGate';

const GateChecking: React.FC<{ readonly load: LoadState }> = ({ load }) => {
  const { t } = useTranslation();
  return (
    <ScreenBody
      fill
      placement="window"
      load={load}
      loadingLabel={t('common.loading', 'Loading...')}
      errorTitle={t('closeTheLoop.settings.errorTitle', 'Couldn’t load your alert settings')}
    >
      {null}
    </ScreenBody>
  );
};

export const OnboardingGate: React.FC<{ readonly children: React.ReactNode }> = ({ children }) => {
  const gate = useOnboardingGate();
  switch (gate.kind) {
    case 'checking':
      return <GateChecking load={gate.load} />;
    case 'redirect':
      return <Navigate to={gate.to} replace state={gate.state} />;
    case 'pass':
      return <>{children}</>;
  }
};
